import $ from 'jquery';
import { CmsHttpSvc } from '@SharedHttpServices/cms.httpservice';
import { hardCodedContent } from './mlt.content';

//need to pull in the other json once we figure this all out with the cms. We can't pull in a million json files because the size will be huge. Might need to load the file you need or something like that
//or just make an ajax call with a list of key's to pull in

//needed because we can't have early stage content for some scenarios


//es-419 or en
export function ResolveStaticContent(contentId) {
    const transformedLanguage = CurrentLanguage() == "en" ? "en" : "es419";

    return hardCodedContent[contentId][transformedLanguage];
}

export function CurrentLanguage() {
    return $('body').attr('data-user-selected-language');
}

class Localization {

    constructor() {
        this.language = CurrentLanguage();
        this.init();
    }

    init() {
        //using init so we can mock this in jest.

        const sessionValidationMessages = JSON.parse(sessionStorage.getItem('VALIDATION_MESSAGES'));

        if (sessionValidationMessages == null || sessionValidationMessages.languageCode !== this.language) {

            CmsHttpSvc.CmsSharedValidationContentBlocks(false)
                .done(rawValidationMessages => {

                    const validationMessages = {
                        languageCode: this.language,
                        content: rawValidationMessages
                    };

                    sessionStorage.setItem('VALIDATION_MESSAGES', JSON.stringify(validationMessages));
                    this.lookup = validationMessages;
                });
        }
        else {
            this.lookup = sessionValidationMessages;
        }
    }

    resolveKeyword(key) {
        return this.lookup.content[key];
    }
}

export const localizationSvc = new Localization();

//usage
//import { localizationSvc } from '../../@SharedServices/localization.service';

//let translation = localizationSvc.resolveKeyword('Account Settings');


